import { useDispatch } from 'react-redux';
import { Col, Alert, Spinner } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { createSelector } from 'reselect';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { getEstablishmentList, getUserList } from '../../../slices/thunks';
import { Link } from 'react-router-dom';
import AddEditUserModal from './Add_Edit/AddEditUserModal';
import DeleteUserModal from './Delete/DeleteUserModal';
import { getRolesList } from '../../../slices/thunks';
import { ODataGrid } from '../../../Components/OElements/ODataGrid';

const UsersList = () => {
	const dispatch = useDispatch();
	const history = useNavigate();

	const selectorUsers = createSelector(
		state => state.Users,
		user => ({
			userList: user.userList,
			isLoadingList: user.isLoadingList,
			isUserSuccess: user.isUserSuccess,
			error: user.error,
			isAdding: user.isAdding,
			isAdded: user.isAdded,
			isAddError: user.isAddError,
			isUpdating: user.isUpdating,
			isUpdated: user.isUpdated,
			isUpdateError: user.isUpdateError,
			isDeleting: user.isDeleting,
			isDeleted: user.isDeleted,
			isDeleteError: user.isDeleteError,
		})
	);

	const selectRolesList = createSelector(
		state => state.Roles.roleListSelect,
		roleListSelect => roleListSelect
	);

	const selectorEstablishment = createSelector(
		state => state.Establishments,
		result => ({
			establishments: result.itemEstablishmentList,
			isLoadingEstablishments: result.isLoadingList
		})
	);


	const roleListSelect = useSelector(selectRolesList);
	const { userList, isLoadingList } = useSelector(selectorUsers);
	const { establishments, isLoadingEstablishments } = useSelector(selectorEstablishment);

	useEffect(() => {
		dispatch(getUserList());
		dispatch(getRolesList());
		dispatch(getEstablishmentList());
	}, []);

	const [dataUser, setDataUser] = useState({});
	const [isEdit, setIsEdit] = useState(false);

	// Delete User
	const [modal, setModal] = useState(false);
	const [modalDelete, setModalDelete] = useState(false);
	//Tab
	const [activeTab, setActiveTab] = useState('1');
	const toggleTab = tab => {
		if (activeTab !== tab) {
			setActiveTab(tab);
		}
	};

	function handleToggleModal() {
		setModal(!modal);
		toggleTab('1');
		// validation.resetForm();
	}

	function handleToggleModalDelete() {
		setModalDelete(!modalDelete);
	}

	// Delete Data
	const handleClickDelete = user => {
		setDataUser(user);
		setModalDelete(true);
	};

	// Update Data
	const handleClickEdit = user => {
		setDataUser(user);
		handleToggleModal();
	};

	const columns = useMemo(
		() => [
			{
				header: 'Acciones', enableSorting: false, enableColumnFilter: false, enableGlobalFilter: false, enableColumnActions: false, enableSorting: false, enableColumnFilter: false, enableGlobalFilter: false, enableColumnActions: false,
				accessorKey: 'user',
				columnDefType: 'display',
				 size: 'auto',
				Cell: cellProps => {
					return (
						<React.Fragment>
							<div className='d-flex'>
								<div className='flex-shrink-0'>
									<ul className='list-inline mb-0'>
										<li className='list-inline-item'>
											<Link
												to='#'
												onClick={() => {
													const userData = cellProps.row.original;
													setIsEdit(true);
													handleClickEdit(userData);
												}}
											>
												<i className='ri-pencil-fill align-bottom me-2 text-muted'></i>
											</Link>
										</li>
										<li className='list-inline-item'>
											<Link
												to='#'
												className='remove-item-btn'
												onClick={() => {
													const userData = cellProps.row.original;
													handleClickDelete(userData);
												}}
											>
												<i className='ri-delete-bin-line align-bottom me-2 text-muted'></i>
											</Link>
										</li>
									</ul>
								</div>
							</div>
						</React.Fragment>
					);
				},
			},
			{ header: 'Nombre', accessorKey: 'full_name',  size: 'auto' },
			{ header: 'Email', accessorKey: 'email',  size: 'auto' },
			{ header: 'Username', accessorKey: 'username',  lowercase: true,  size: 'auto' },
			{
				header: 'Perfil', accessorKey: 'role',  size: 'auto',
				dataType: 'string',
				Cell: ({ row }) => (
					<div>
						{
							roleListSelect?.find(
								role => role.item._id === row.original.role
							)?.item.name.toString()
						}
					</div>
				),
			},
			{
				header: 'Establecimiento por Defecto',
				accessorKey: 'establishment_default_id',
				
				dataType: 'string',
				size: 'auto',
				Cell: ({ row }) => {
					const establishmentName = row?.original?.establishment_default_id
						? establishments?.find(
							establishment => establishment._id === row.original.establishment_default_id
						)?.name.toString()
						: "-";
					return (
						<div>
							{establishmentName}
						</div>
					);
				}
			},
			{
				header: 'Establecimiento Activo',
				accessorKey: 'establishment_active_id',
				
				dataType: 'string',
				size: 'auto',
				Cell: ({ row }) => {
					const establishmentName = row?.original?.establishment_active_id
						? establishments?.find(
							establishment => establishment._id === row.original.establishment_active_id
						)?.name.toString()
						: "-";
					return (
						<div>
							{establishmentName}
						</div>
					);
				}
			},

			{
				header: 'Ingreso por Proveedor', accessorKey: 'active_directory',  size: 'auto', dataType: 'boolean',
				Cell: ({ row }) => {
					return (
						<input
							className='form-check-input'
							role='switch'
							type='checkbox'
							id='active_directory'
							name='active_directory'
							disabled
							checked={row.original.active_directory}
						/>
					);
				},
			},
			{
				header: 'Politica de Privacidad', accessorKey: 'privacy_policy',  size: 'auto', dataType: 'boolean',
				Cell: ({ row }) => {
					return (
						<input
							className='form-check-input'
							role='switch'
							type='checkbox'
							id='privacy_policy'
							name='privacy_policy'
							disabled
							checked={row.original.privacy_policy}
						/>
					);
				},
			},
			// {
			// 	header: 'Terminos de Uso', accessorKey: 'terms_condition',  size: 'auto', dataType: 'boolean',
			// 	Cell: ({ row }) => {
			// 		return (
			// 			<input
			// 				className='form-check-input'
			// 				role='switch'
			// 				type='checkbox'
			// 				id='terms_condition'
			// 				name='terms_condition'
			// 				disabled
			// 				checked={row.original.terms_condition}
			// 			/>
			// 		);
			// 	},
			// },
			{
				header: 'Desactivado',
				accessorKey: 'disabled',
				
				size: 'auto',
				Cell: ({ row }) => {
					return (
						<input
							className='form-check-input'
							role='switch'
							type='checkbox'
							id='disabled'
							name='disabled'
							disabled
							checked={row.original.disabled}
						/>
					);
				},
			},
		],
		[handleClickEdit]
	);

	return (
		<React.Fragment>
			<div className='row'>
				<Col lg={12}>
					<div className='card'>
						{/* <div className='card-header border-0'>
							<div className='d-flex align-items-center'>
								<h5 className='card-title mb-0 flex-grow-1'>
									Usuarios
								</h5>
								<div className='flex-shrink-0'>
									<div className='d-flex flex-wrap gap-2'>
										<button
											className='btn btn-label btn-primary'
											onClick={() => {
												setIsEdit(false);
												setDataUser({});
												handleToggleModal();
											}}
										>
											<i className={`${Icons.plus} label-icon`}></i>{' '}
											Crear Usuario
										</button>
									</div>
								</div>
							</div>
						</div> */}
						<div className='card-body pt-3'>
							<ODataGrid
								columns={columns}
								data={userList || []}
								isLoadingData={isLoadingList}
								nameFile={'usuarios'}
								customToolbarActions={[
									{
										label: 'Crear',
										icon: Icons.plus,
										className: 'gap-1',
										onClick: () => {
												setIsEdit(false);
												setDataUser({});
												handleToggleModal();
											},
										title: 'Crear Usuario',
									}
								]}
							/>
						</div>
					</div>
				</Col>
			</div>

			<AddEditUserModal
				dataUser={dataUser}
				isEdit={isEdit}
				isOpen={modal}
				handleToggleModal={handleToggleModal}
				activeTab={activeTab}
				toggleTab={toggleTab}
			/>
			<DeleteUserModal
				dataUser={dataUser}
				isOpen={modalDelete}
				handlerToggleModal={handleToggleModalDelete}
			/>
		</React.Fragment>
	);
};

export default UsersList;
